import { render, staticRenderFns } from "./JTMSDashboard.vue?vue&type=template&id=33db7ee0&scoped=true&"
import script from "./JTMSDashboard.vue?vue&type=script&lang=ts&"
export * from "./JTMSDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db7ee0",
  null
  
)

export default component.exports